var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NotificationsService } from "angular2-notifications";
import { UserService } from "../../../services/user.service";
import { EduComponent } from "../../../utils/eduComponent";
import Utils from "../../../utils/utils";
var StudentAssignmentsComponent = /** @class */ (function (_super) {
    __extends(StudentAssignmentsComponent, _super);
    function StudentAssignmentsComponent(userService, notificationService) {
        var _this = _super.call(this) || this;
        _this.userService = userService;
        _this.notificationService = notificationService;
        _this.assignmentcode = "";
        _this.hasError = false;
        _this.populationComplete = false;
        _this.defaultLimit = 5;
        _this.displayableAssignments = [];
        _this.assignments = [];
        _this.activeAssignments = [];
        _this.activityTypes = {
            lessonBuilder: 0,
            storyboardAssignment: 1,
            standalonePuzzle: 2,
            standaloneQuiz: 3,
        };
        _this.checkSignURL = require("../../../../assets/student/check.svg");
        _this.addSub(_this.userService.assignments.subscribe(function (assignments) {
            _this.assignments = assignments.slice();
            _this.assignments.sort(function (assignment1, assignment2) {
                return assignment1.date_created > assignment2.date_created ? -1 : 1;
            });
            _this.displayableAssignments = _this.assignments.slice(0, _this.defaultLimit);
            _this.populationComplete = true;
        }));
        return _this;
    }
    StudentAssignmentsComponent.prototype.isActive = function (code) {
        return this.activeAssignments.indexOf(code) > -1;
    };
    StudentAssignmentsComponent.prototype.toggleActive = function (code) {
        var index = this.activeAssignments.indexOf(code);
        if (index > -1) {
            this.activeAssignments.splice(index, 1);
        }
        else {
            this.activeAssignments.push(code);
        }
    };
    StudentAssignmentsComponent.prototype.isPosterAssignment = function (assignment) {
        return (assignment.activity.type === this.activityTypes.storyboardAssignment);
    };
    StudentAssignmentsComponent.prototype.isPuzzleAssignment = function (assignment) {
        return assignment.activity.type === this.activityTypes.standalonePuzzle;
    };
    StudentAssignmentsComponent.prototype.isQuizAssignment = function (assignment) {
        return assignment.activity.type === this.activityTypes.standaloneQuiz;
    };
    StudentAssignmentsComponent.prototype.isLesson = function (assignment) {
        return (!this.isPosterAssignment(assignment) &&
            !this.isPuzzleAssignment(assignment) &&
            !this.isQuizAssignment(assignment));
    };
    StudentAssignmentsComponent.prototype.isIlp = function (assignment) {
        return assignment.activity.is_ilp;
    };
    StudentAssignmentsComponent.prototype.shouldPaginate = function () {
        if (this.defaultLimit != null) {
            return this.assignments.length > this.defaultLimit;
        }
    };
    StudentAssignmentsComponent.prototype.showMore = function () {
        this.defaultLimit += 5;
        this.displayableAssignments = this.assignments.slice(0, this.defaultLimit);
        if (this.defaultLimit > this.assignments.length / 2) {
            this.userService.loadMoreAssignments();
        }
    };
    StudentAssignmentsComponent.prototype.submitAssignmentsForm = function ($event) {
        var _this = this;
        $event.preventDefault();
        this.userService
            .validateCode(this.assignmentcode)
            .subscribe(function (data) {
            if (data.url && data.url.length > 0) {
                window.location.href = data.url;
            }
            else if (data.error) {
                _this.notificationService.error("", data.error, Utils.alertConfiguration);
            }
        });
    };
    StudentAssignmentsComponent.prototype.startAssignment = function (assignment) {
        var _this = this;
        if (!this.userService.isStudent()) {
            var teacherResourceURI = assignment.activity.teacher_resource_uri;
            var activityCreatorPk = teacherResourceURI.substring(13, teacherResourceURI.lastIndexOf("/"));
            if (Number.parseInt(activityCreatorPk) ===
                this.userService.getUserPK()) {
                return (window.location.href =
                    window.location.origin + assignment.activity.preview_url);
            }
        }
        var updateObj = {
            status: "started",
            student_name: " ",
        };
        this.userService.updateResult(assignment.id, updateObj).subscribe(function (data) {
            if (data.data && data.data.location) {
                window.location.href = data.data.location;
            }
            else {
                window.location.href = assignment.student_result_url;
            }
        }, function (error) {
            var message = "An error occurred while starting the assignment. Please refresh and try again!";
            if (error.error &&
                error.error.result &&
                error.error.result.status) {
                message = error.error.result.status;
            }
            _this.notificationService.error("Uh oh!", message, Utils.alertConfiguration);
        });
    };
    return StudentAssignmentsComponent;
}(EduComponent));
export { StudentAssignmentsComponent };
